import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TeamVariant } from '../../../shared/models/type-list';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';

@Component({
  selector: 'app-view-dup-model-dialog',
  imports: [CommonModule, MatDialogModule, MatCardModule, MatTableModule],
  templateUrl: './view-dup-model-dialog.component.html',
  styleUrl: './view-dup-model-dialog.component.scss'
})

export class ViewDupModelDialogComponent {
pitch_id: string = '';

  constructor(
    public dialogRef: MatDialogRef<ViewDupModelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ViewData) {
      this.pitch_id = data.pitch_id;
  }

  get variantNames(): string[] {
    return Object.keys(this.data?.dup_list?.variant_name || {});
  }

  getModelNames(variant: string): string[] {
    return this.data?.dup_list?.variant_name?.[variant]?.model_name || [];
  }
}

export interface DupVariantEntry {
  model_name: string[];
}

export interface DupList {
  variant_name: { [variantName: string]: DupVariantEntry };
  all_duplicated_model_names: string[];
}

export interface ViewData {
  dup_list: DupList;
  pitch_id: string;
}

